module.exports = __webpack_public_path__ + "statics/img/logo.6aa2e32e.jpg";